import React from 'react';
import './Circulos.scss';

class ComoSoy extends React.Component {
  render () {
    return (
      <div className="circulos__container">
        <div className="description__container">
          <h1 className="circulos__title">Lorem ipsum</h1>
          <p className="circulo__main__text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae, condimentum nec nisl. Nulla facilisi. Nullam placerat, lectus non sodales facilisis, lacus massa sagittis sapien, nec cursus dui mi id risus. Suspendisse eu ante vel ligula fringilla imperdiet sed vehicula lacus. Quisque eleifend arcu ut nibh semper congue. Sed efficitur sollicitudin eros non ullamcorper. Suspendisse ut sodales tellus. Pellentesque faucibus posuere imperdiet. Ut non lacus aliquet, lobortis risus eget, cursus mi. Vivamus velit nunc, convallis in tortor id, vulputate laoreet metus. Quisque lectus sem, auctor ac dui sit amet, vestibulum maximus felis. Ut porta in velit ac porta. Fusce vitae enim tortor. Nullam dui felis, aliquam vitae ex et, lobortis cursus purus. In ut vulputate ante. Morbi posuere, mi nec luctus viverra, nisl arcu viverra mauris, at convallis leo purus nec sem.</p>
          <h2 className="circulos__subtitle">Lorem ipsum</h2>
          <h3 className="circulos__sub__subtitle">Lorem ipsum</h3>
          <ul className="circulos__list">
            <li className="circulos__list__item"><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae</li>
            <li className="circulos__list__item"><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae</li>
            <li className="circulos__list__item"><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae</li>
            <li className="circulos__list__item"><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae</li>
            <li className="circulos__list__item"><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae</li>
            <li className="circulos__list__item"><strong>Lorem ipsum: </strong>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim, tincidunt id dignissim vitae</li>
          </ul>
        </div>
        <div className="circle__container">
          <div className="circle__item circle__one">
            <h5 className="circle__item__title">Item One</h5>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim</p>
          </div>
          <div className="circle__item circle__two">
            <h5 className="circle__item__title">Item Two</h5>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim</p>
          </div>
          <div className="circle__item circle__three">
            <h5 className="circle__item__title">Item Three</h5>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim</p>
          </div>
          <div className="circle__item circle__four">
            <h5 className="circle__item__title">Item Four</h5>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui enim</p>
          </div>
        </div>
      </div>
    )
  }
}

export default ComoSoy;
